export const unusedNonce = 0;
export const unusedArbiterFee = 0n;
/**
 * Runtime value for the EVM Platform
 * */
export const _platform = 'Evm';
export const addFrom = (txReq, from) => ({
    ...txReq,
    from,
});
export const addChainId = (txReq, chainId) => ({
    ...txReq,
    chainId,
});
export const addValue = (txReq, value) => ({
    ...txReq,
    value,
});
//# sourceMappingURL=types.js.map